export default __webpack_public_path__ + "static/media/IconDesc_SteelBeam.256.10e441e7.png";